<template>
    <div>
        <modal id="feedback-modal">
            <template slot="body">

                <h2 class="font-weight-bolder text-app">Your feedback is important to us!</h2>

                <div class="py-3 text-muted mt-2">
                    Please take a few moments to complete this short survey.<br>
                    Your feedback will help us continue to improve the Acceptance Testing Software.
                </div>

                <div class="py-3 text-muted mb-2">
                    How would you rate your experience using the AT Software?
                </div>

                <div class="d-flex justify-content-between px-4 mb-4">
                    <template v-for="index in 5">
                        <a href="#" @click="form.score = index">
                            <i class="fas fa-star fa-3x"
                               :class="{'text-warning': form.score >= index, 'text-muted' : form.score < index }">
                            </i>
                        </a>
                    </template>
                </div>

                <div class="py-3 text-muted">
                    In a few words, can you provide us with any additional comments or suggestions you feel would improve your experience using the Acceptance Testing Software.
                </div>

                <field-text v-model="form.feedback"></field-text>

                <div class="d-flex">
                    <button class="btn btn-success ml-auto" @click="save">Send</button>
                </div>
            </template>
        </modal>
    </div>
</template>
<script>
export default {

    data() {
        return {
            form: new Form({
                score: 0,
                feedback: '',
            }),
        }
    },

    mounted(){
      this.openModal('feedback-modal')
    },

    methods: {
        save() {
            this.form.post(`/feedback`).then(response => {
                this.closeModal('feedback-modal')
                Alert.success('Thank You!')
            }).catch(errors => {
                Alert.error(errors.first())
            })
        }
    }
}
</script>
